/* eslint-disable react/prop-types */
/// <reference types="react-scripts" />
import StudyProjectCard from "../../common/studyProjectCard";
import swarmMarket from "../../assets/projects/swarmMarket.png";
import diaOracles from "../../assets/projects/DIA-Oracles-on-Kadena.png";
import aragonDAO from "../../assets/projects/aragonDAO.png";
import balancerVe8020 from "../../assets/projects/balancerVe8020.png";
import cowswap from "../../assets/projects/cowswap.png";
import aethir from "../../assets/projects/aethir.png";

function StudiesProjectsCards() {
  return (
    <div className="mt-14 grid grid-cols-6 gap-8">
      <StudyProjectCard
        imgSrc={aethir}
        title="Staking Module for Aethir"
        tagList={["Staking", "Module"]}
        text="The explosive growth of AI, gaming, and cloud computing has exposed the limitations of centralized infrastructure, driving demand for scalable, efficient, and decentralized alternatives. Aethir, a leader in Decentralized Physical Infrastructure Networks (DePIN), is meeting this need by connecting underutilized enterprise-grade GPUs with global users through a blockchain-powered marketplace."
        link="/projects/aethir"
        className="col-span-6 md:col-span-3 xl:col-span-2"
      />
      <StudyProjectCard
        imgSrc={balancerVe8020}
        title="Ve8020 Launchpad for Balancer"
        tagList={["Launchpad", "Platform", "Solution"]}
        text="The ve8020 Launchpad represents a significant milestone for Balancer, developed by Protofire through a community grant. This innovative platform provides a streamlined solution for projects to launch veTokens using 80/20 Balancer pools, promoting efficient tokenomics and fostering ecosystem growth."
        link="/projects/balancer"
        className="col-span-6 md:col-span-3 xl:col-span-2"
      />
      <StudyProjectCard
        imgSrc={cowswap}
        title="CowSwap DEX"
        tagList={["dApp", "DeFi", "DEX"]}
        text="Protofire has been working in sync with the CoW Protocol team in the rebranding, development, and testing of a web trading interface built on top of the protocol, which allows users to buy and sell tokens using gas-less orders, as well as the improvement of an affiliate program to promote the referrals in the community."
        link="/projects/cowswap-dex"
        className="col-span-6 md:col-span-3 xl:col-span-2"
      />
      <StudyProjectCard
        imgSrc={diaOracles}
        title="DIA Oracles on Kadena"
        tagList={["Oracle", "Smart Contract"]}
        text="Protofire integrated DIA oracles on Kadena, enabling 14 asset price feeds for blockchain protocols. Learn about our innovative approach to expanding oracle services and enhancing DeFi capabilities on the Kadena network."
        link="/projects/dia-oracles-kadena"
        className="col-span-6 md:col-span-3"
      />
      <StudyProjectCard
        imgSrc={aragonDAO}
        title="AragonDAO Payroll dApp"
        tagList={["dApp", "Dashboard", "Payments"]}
        text="The Aragon application allows users to incorporate new employees (integrated with the identity and finance apps), request and pre-authorize payments in different tokens, as well as view all the payroll information, including historic payments, balance, and statistics."
        link="/projects/aragon-dapp"
        className="col-span-6 md:col-span-3"
      />
      <StudyProjectCard
        imgSrc={swarmMarket}
        title="Swarm Markets DEX"
        tagList={["dApp", "Dashboard", "DeFi"]}
        text="Protofire has received several grants from Protocol Labs and has been working together with the Protocol Labs team (as contributors to Glif tools) since before the launch of the Filecoin Mainnet."
        link="/projects/swarm-dex"
        className="col-span-6 md:col-span-3 xl:hidden"
      />
    </div>
  );
}

export default StudiesProjectsCards;
